<template>
    <div class="mapContent">
        <MapLeft
            ref="mapLeft"
            :locationObj="locationObj"
            :enableRepoint="enableRepoint"
            :location.sync="location"
            @searchResult="searchResult"
        />
        <MapRight
            :mapObj.sync="mapObjNew"
            :carrierScene="carrierScene"
            :treeObj="treeObj"
            :enableRepoint.sync="enableRepoint"
            :location="location"
            @addressSearchFn="addressSearchFn"
        />
    </div>
</template>

<script>
import MapLeft from './map/MapLeft-mapbox.vue';
import MapRight from './map/MapRight.vue';

export default {
    components: {
        MapLeft,
        MapRight
    },
    props: {
        treeObj: {
            type: Object,
            default: () => ({})
        },
        mapObj: {
            type: Object,
            default: () => ({})
        },
        carrierScene: {
            type: Array,
            default: () => ([])
        }
    },
    data(){
        return {
            enableRepoint: false,
            location: null,
            mapObjNew: {}
        }
    },
    watch: {
        mapObj: {
            handler(newVal) {
                this.mapObjNew = { ...newVal}
            },
            immediate: true,
            deep: true
        },
    },
    computed: {
        locationObj() {
            const idx = this.carrierScene.findIndex(item => item.abnormal === 1)
            const { address, longitude, latitude } = this.mapObjNew
            return { address, longitude: longitude, latitude: latitude, abnormal: idx !== -1 }
        }
    },
    methods:{
        addressSearchFn(address) {
            if (this.$refs.mapLeft) {
                this.$refs.mapLeft.searchAddress(address);
            }
        },
        searchResult(address) {
        }
    }
}
</script>

<style scoped>
.mapContent {
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
}
</style>
